import React, { useEffect, useState, useRef } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Modal } from "antd";
import { FaEye, FaEyeSlash, FaCheck, FaTimes } from "react-icons/fa";
import Select from "react-select";



const generateCaptcha = () => {
  const num1 = Math.floor(Math.random() * 10);
  const num2 = Math.floor(Math.random() * 10);
  return {
    question: `${num1} + ${num2} = ?`,
    answer: (num1 + num2).toString(),
  };
};

const CreateAbhaModal = ({
  isOpen,
  onClose,
  onSuccess,
  initialMobileNumber = "",
  showAsModal = false,
}) => {

  const inputRefs = useRef([]);
  const otpRefs = useRef([]); // Add refs for OTP inputs
  const [visible, setVisible] = useState(false);
  const [currentStep, setCurrentStep] = useState(1);
  const [aadhaar, setAadhaar] = useState(["", "", ""]);
  const [show, setShow] = useState(false);
  const [captcha, setCaptcha] = useState(generateCaptcha());
  const [captchaAnswer, setCaptchaAnswer] = useState("");
  const [isCaptchaCorrect, setIsCaptchaCorrect] = useState(false);
  const [isAgreed, setIsAgreed] = useState(false);
  const [otp, setOtp] = useState(Array(6).fill(""));
  const [otpTimer, setOtpTimer] = useState(0);
  const [mobileMesaage, setmobileMesaage] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [errorMessage, setErrorMessage] = useState(""); // Error messages
  const [abhaAddress, setAbhaAddress] = useState(""); // Input for ABHA address
  const [abhaAddressError, setAbhaAddressError] = useState(""); // Validation error message
  const [suggestions, setSuggestions] = useState([]); // Suggestions
  const [showAadhaar, setShowAadhaar] = useState(false);
  // Resend states for Aadhaar OTP
  const [aadhaarResendAttempts, setAadhaarResendAttempts] = useState(0);
  const [isAadhaarResendDisabled, setIsAadhaarResendDisabled] = useState(true);
  const [aadhaarOtpTimer, setAadhaarOtpTimer] = useState(0);

  // Resend states for Communication OTP
  const [commResendAttempts, setCommResendAttempts] = useState(0);
  const [isCommResendDisabled, setIsCommResendDisabled] = useState(true);
  const [commOtpTimer, setCommOtpTimer] = useState(0);

   const API_URL1 = process.env.REACT_APP_API_URL_V2;
  const MAX_AADHAAR_RESEND_ATTEMPTS = 2;
  const navigate = useNavigate();

  const [txnId, setTxnId] = useState(null);
  const [otpSent, setOtpSent] = useState(false);
  const [email, setEmail] = useState(""); // User's email
  const [emailOtp, setEmailOtp] = useState(Array(6).fill("")); // OTP digits for email
  const [emailOtpSent, setEmailOtpSent] = useState(false);
  const [aadhaarResponse, setAadhaarResponse] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [otpMessage, setOtpMessage] = useState("");

  const healthWorkerName = "";
  const [beneficiaryName, setBeneficiaryName] = useState("");
  const beneficiaryInputRef = useRef(null);

  useEffect(() => {
    if (isOpen && showAsModal) {
      setCurrentStep(1);
      setMobileNumber(initialMobileNumber);
      // Reset all other states...
    }
  }, [isOpen, showAsModal, initialMobileNumber]);
  const consentItems = [
    {
      key: "shareAadhaar",
      label: `I am voluntarily sharing my Aadhaar Number / Virtual ID issued by the Unique Identification Authority of India (“UIDAI”), and my demographic information for the purpose of creating an Ayushman Bharat Health Account number (“ABHA number”) and Ayushman Bharat Health Account address (“ABHA Address”). I authorize NHA to use my Aadhaar number / Virtual ID for performing Aadhaar based authentication with UIDAI as per the provisions of the Aadhaar (Targeted Delivery of Financial and other Subsidies, Benefits and Services) Act, 2016 for the aforesaid purpose. I understand that UIDAI will share my e-KYC details, or response of “Yes” with NHA upon successful authentication.`,
    },
    {
      key: "linkLegacy",
      label: `I consent to usage of my ABHA address and ABHA number for linking of my legacy (past) health records and those which will be generated during this encounter.`,
    },
    {
      key: "shareHealthRecords",
      label: `I authorize the sharing of all my health records with healthcare provider(s) for the purpose of providing healthcare services to me during this encounter.`,
    },
    {
      key: "anonymization",
      label: `I consent to the anonymization and subsequent use of my health records for public health purposes.`,
    },
    {
      key: "informedByWorker",
      label: `I, ${healthWorkerName} confirm that I have duly informed and explained the beneficiary of the contents of consent for aforementioned purposes.`,
    },
    {
      key: "beneficiaryConsent",
      label: `I, ${
        beneficiaryName || "_______________"
      }, have been explained about the consent as stated above and hereby provide my consent for the aforementioned purposes.`,
    },
  ];
  const [consentState, setConsentState] = useState(
    consentItems.reduce((acc, item) => {
      acc[item.key] = false;
      return acc;
    }, {})
  );
  const allConsented = Object.values(consentState).every(Boolean);

  const debounce = (func, delay) => {
    let timer;
    return function (...args) {
      clearTimeout(timer);
      timer = setTimeout(() => func(...args), delay);
    };
  };

  //   useEffect(() => {
  //     validateToken(navigate);
  //   }, [navigate]);

  // Resend Aadhaar OTP Function
  
  const handleResendAadhaarOtp = async () => {
    if (aadhaarResendAttempts >= 2) {
      toast.error("Resend OTP exhausted. Please try again later.");
      return;
    }

    refreshCaptcha();

    try {
      const aadhaarNumber = aadhaar.join("");

      setIsAadhaarResendDisabled(true);
      const response = await fetch(
        `${API_URL1}abdm/sendOtp?adhaar=${aadhaarNumber}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      const data = await response.json();
      if (response.ok) {
        if (
          data.data &&
          !data.data.error &&
          data.data.message &&
          data.data.txnId
        ) {
          setOtpMessage(data.data.message);
          setTxnId(data.data.txnId); // Update txnId with the latest value
          // Clear the OTP fields when resending
          setOtp(Array(6).fill(""));
          setAadhaarResendAttempts((prev) => prev + 1); // Increment resend attempts
          setAadhaarOtpTimer(60); // Reset the timer
          toast.success(data.data.message || "OTP has been resent!");
        } else {
          toast.error(
            data.message || "Failed to resend OTP. Please try again."
          );
          setIsAadhaarResendDisabled(false); // Re-enable if API response is not successful
        }
      } else {
        if (data && data.data && data.data === "Invalid LoginId") {
          toast.error(
            "Invalid Aadhaar number. Please enter a correct Aadhaar number."
          );
        } else if (data && data.data) {
          toast.error(
            data.data || "Failed to resend OTP. Please try again later."
          );
        } else {
          toast.error("Failed to resend OTP. Please try again later.");
        }
        setIsAadhaarResendDisabled(false); // Re-enable if response is not ok
      }
    } catch (error) {
      console.error("Error during resend Aadhaar OTP:", error);
      toast.error("An error occurred while resending OTP. Please try again.");
      setIsAadhaarResendDisabled(false); // Re-enable on error
    }
  };

  // Resend Communication OTP Function
  const handleResendOtpConfirm = async () => {
    if (commResendAttempts >= 2) {
      toast.error("Resend OTP exhausted. Please try again later.");
      return;
    }

    try {
      const mobileNo = mobileNumber;

      setIsCommResendDisabled(true);
      const response = await fetch(
        `${API_URL1}abdm/resend-communication-otp?mobileNumber=${mobileNo}&txnId=${txnId}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.ok) {
        const data = await response.json();
        if (data.data && data.data.message && data.data.txnId) {
          setOtpMessage(data.data.message);
          setTxnId(data.data.txnId); // Update txnId with the latest value
          // Clear the OTP fields when resending
          setOtp(Array(6).fill(""));
          setCommResendAttempts((prev) => prev + 1); // Increment resend attempts
          setCommOtpTimer(60); // Reset the timer
          toast.success(data.data.message || "OTP has been resent!");
        } else {
          toast.error(
            data.message || "Failed to resend OTP. Please try again."
          );
          setIsCommResendDisabled(false); // Re-enable if API response is not successful
        }
      } else {
        toast.error("Failed to resend OTP. Please try again later.");
        setIsCommResendDisabled(false); // Re-enable if response is not ok
      }
    } catch (error) {
      console.error("Error during resend Communication OTP:", error);
      toast.error("An error occurred while resending OTP. Please try again.");
      setIsCommResendDisabled(false); // Re-enable on error
    } finally {
      // Re-enable the button after 60 seconds
      setTimeout(() => setIsCommResendDisabled(false), 60000);
    }
  };

  // Verify Mobile OTP Function
  const handleVerifyMobileOtp = async () => {
    const enteredOtp = otp.join("");
    if (enteredOtp.length !== 6) {
      toast.error("Please enter a complete 6-digit OTP.");
      return;
    }
    const payload = {
      txnId: txnId, // Use the latest txnId from state
      otp: enteredOtp,
    };
    setIsLoading(true);
    try {
      const response = await fetch(
        `${API_URL1}abdm/communication-mobile-verify-otp`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        }
      );
      const data = await response.json();
      if (response.ok) {
        if (data.status === 200) {
          toast.success(data.message || "Mobile OTP verified successfully!");
          setOtpSent(false);
          // Proceed with next steps or update state as needed
        } else {
          toast.error(
            data.message || "Failed to verify OTP. Please try again."
          );
        }
      } else {
        toast.error(
          data.data || "Failed to verify OTP. Please try again later."
        );
      }
    } catch (error) {
      console.error("Error verifying OTP:", error);
      toast.error("An error occurred while verifying OTP. Please try again.");
    } finally {
      setIsLoading(false);
      setOtp(Array(6).fill(""));
    }
  };

  // Send Email OTP Function
  const handleSendEmailOtp = async () => {
    setIsLoading(true);
    try {
      const abhaId = aadhaarResponse?.preferredAbhaAddress;
      const url = `${API_URL1}abdm-profile/verify-email?abhaId=${abhaId}&email=${email}`;
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (response.ok) {
        const data = await response.json();
        if (data.status === 200) {
          toast.success(
            data.data.message || "Email verification link sent successfully!"
          );
          setEmailOtpSent(true);
          setCurrentStep(4);
        } else {
          toast.error(data.message || "Failed to send OTP. Please try again.");
        }
      } else {
        const errorText = await response.text();
        toast.error(
          `Failed to send OTP. Status: ${response.status}. Error: ${errorText}`
        );
      }
    } catch (error) {
      console.error("Error sending email OTP:", error);
      toast.error("An error occurred while sending OTP. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  const handleEmailOtpChange = (e, index) => {
    const value = e.target.value;
    if (/^\d$/.test(value) || value === "") {
      const newOtp = [...emailOtp];
      newOtp[index] = value;
      setEmailOtp(newOtp);
    }
  };

  const handleFetchSuggestions = async () => {
    try {
      const response = await fetch(
        `${API_URL1}abdm/abhaAddressSuggestion?txnId=${aadhaarResponse.txnId}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.ok) {
        const data = await response.json();
        console.log("API Response:", data);

        if (data.data && data.data.abhaAddressList) {
          setSuggestions(data.data.abhaAddressList);
        } else {
          setSuggestions([]);
        }
      } else {
        console.error("Failed to fetch suggestions. Status:", response.status);
        toast.error("Failed to fetch suggestions.");
      }
    } catch (error) {
      console.error("Error during API call:", error);
      toast.error("An error occurred while fetching suggestions.");
    }
  };

  const isValidAbhaAddress = (address) => {
    if (!address) {
      return false;
    }
    if (address.length < 8 || address.length > 18) {
      return false;
    }
    if (/^[._]|[._]$/.test(address)) {
      return false;
    }
    const dotCount = (address.match(/\./g) || []).length;
    const underscoreCount = (address.match(/_/g) || []).length;
    if (dotCount > 1 || underscoreCount > 1) {
      return false;
    }
    if (!/^[a-zA-Z0-9._]+$/.test(address)) {
      return false;
    }
    if (!/[a-zA-Z0-9]/.test(address)) {
      return false;
    }
    return true;
  };

  const handleAbhaAddressChange = (value) => {
    setAbhaAddress(value);

    if (!isValidAbhaAddress(value)) {
      setAbhaAddressError(
        "ABHA Address must be 8–18 characters, alphanumeric, and may include 1 dot (.) and/or 1 underscore (_), only in between."
      );
    } else {
      setAbhaAddressError("");
    }
  };

  useEffect(() => {
    refreshCaptcha();
    if (currentStep === 4) {
      handleFetchSuggestions();
    }
  }, [currentStep]);

  // Aadhaar OTP Timer Effect
  useEffect(() => {
    let timer;
    if (aadhaarOtpTimer > 0) {
      timer = setInterval(() => {
        setAadhaarOtpTimer((prev) => prev - 1);
      }, 1000);
    } else {
      setIsAadhaarResendDisabled(false); // Enable the resend button
    }
    return () => clearInterval(timer);
  }, [aadhaarOtpTimer]);

  useEffect(() => {
    let timer;
    if (commOtpTimer > 0) {
      timer = setInterval(() => {
        setCommOtpTimer((prev) => prev - 1);
      }, 1000);
      setIsCommResendDisabled(true);
    } else {
      setIsCommResendDisabled(false); // Enable the resend button
    }
    return () => clearInterval(timer);
  }, [commOtpTimer]);

  useEffect(() => {
    if (currentStep === 2 || currentStep === 3) {
      setOtp(Array(6).fill(""));
      // Focus on first OTP input when step changes
      setTimeout(() => {
        otpRefs.current[0]?.focus();
      }, 100);
    }
  }, [currentStep]);

  const handleOtpChange = (value, index) => {
    if (!/^\d?$/.test(value)) return;

    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);
    
    // Move to next input if value is entered
    if (value && index < otp.length - 1) {
      setTimeout(() => {
        otpRefs.current[index + 1]?.focus();
      }, 10);
    }
  };

  const handleOtpKeyDown = (index, event) => {
    if (event.key === "Backspace") {
      const newOtp = [...otp];
      if (otp[index]) {
        // Clear current field
        newOtp[index] = "";
        setOtp(newOtp);
      } else if (index > 0) {
        // Move to previous field and clear it
        setTimeout(() => {
          otpRefs.current[index - 1]?.focus();
        }, 10);
        newOtp[index - 1] = "";
        setOtp(newOtp);
      }
    }
  };

  const handleAadhaarChange = (index, value) => {
    const newAadhaar = [...aadhaar];
    newAadhaar[index] = value.replace(/\D/g, "").slice(0, 4);
    setAadhaar(newAadhaar);
    if (value.length === 4 && index < aadhaar.length - 1) {
      inputRefs.current[index + 1].focus();
    }
  };

  const handleAadhaarKeyDown = (index, event) => {
    if (event.key === "Backspace" && aadhaar[index] === "" && index > 0) {
      inputRefs.current[index - 1].focus();
    }
  };

  const toggleShowAadhaar = () => {
    setShowAadhaar((prev) => !prev);
  };

  const handleCaptchaChange = (value) => {
    setCaptchaAnswer(value);
    setIsCaptchaCorrect(value === captcha.answer);
  };

  const refreshCaptcha = () => {
    setCaptcha(generateCaptcha());
    setCaptchaAnswer("");
    setIsCaptchaCorrect(false);
    // toast.info("Captcha refreshed!");
  };

  const handleNextStep = async () => {
    if (isLoading) return;
    setIsLoading(true);

    refreshCaptcha();
    try {
      if (currentStep === 1) {
        if (aadhaar.some((seg) => seg.length !== 4)) {
          toast.error("Please fill all Aadhaar number fields correctly.");
          return;
        }
        if (!allConsented) {
          toast.warning(
            "Please provide consent for all clauses before proceeding."
          );
          return;
        }
        if (!isCaptchaCorrect) {
          toast.error("Captcha is incorrect. Please try again.");
          return;
        }
        if (!beneficiaryName.trim()) {
          toast.error("Please enter the beneficiary’s name.");
          // beneficiaryInputRef.current.focus();
          return;
        }
        const aadhaarNumber = aadhaar.join("");

        try {
          console.log("Calling API to send OTP...");
          const response = await fetch(
            `${API_URL1}abdm/sendOtp?adhaar=${aadhaarNumber}`,
            {
              method: "GET",
              headers: {
                "Content-Type": "application/json",
              },
            }
          );

          const data = await response.json();
          if (response.ok) {
            if (
              data.data &&
              !data.data.error &&
              data.data.message &&
              data.data.txnId
            ) {
              setOtpMessage(data.data.message);
              toast.success(data.data.message);
              setTxnId(data.data.txnId);
              setCurrentStep(2); // Move to Step 2

              // **Start Resend Timer for Aadhaar OTP**
              setAadhaarOtpTimer(60);
              setIsAadhaarResendDisabled(true);
              setAadhaarResendAttempts(0); // Reset attempts if needed
            } else {
              if (
                data &&
                data.data &&
                data.data.message === "Invalid LoginId"
              ) {
                toast.error(
                  "Invalid Aadhaar number. Please enter a correct Aadhaar number."
                );
              } else if (data && data.data) {
                toast.error(
                  data.data.message ||
                    "Failed to resend OTP. Please try again later."
                );
              } else {
                toast.error("Failed to resend OTP. Please try again later.");
              }
            }
          } else {
            if (data && data.data && data.data === "Invalid LoginId") {
              toast.error(
                "Invalid Aadhaar number. Please enter a correct Aadhaar number."
              );
            } else if (data && data.data) {
              toast.error(
                data.data || "Failed to resend OTP. Please try again later."
              );
            } else {
              toast.error("Failed to resend OTP. Please try again later.");
            }
          }
        } catch (error) {
          console.error("Network Error while sending OTP:", error);
          toast.error("An error occurred while sending OTP. Please try again.");
        }
      } else if (currentStep === 2) {
        console.log("Step 2: Aadhaar Authentication...");
        if (!txnId) {
          toast.error("Transaction ID is missing. Please restart the process.");
          console.error("Error: Transaction ID is missing.");
          return;
        }
        if (mobileNumber.length !== 10 || !/^[6-9]\d{9}$/.test(mobileNumber)) {
          const error =
            "Please enter a valid 10-digit mobile number starting with 6, 7, 8, or 9.";
          console.error(error);
          setErrorMessage(error);
          return;
        }
        if (otp.some((digit) => digit === "")) {
          const error = "Please enter a complete 6-digit OTP.";
          console.error(error);
          setErrorMessage(error);
          return;
        }

        const payload = {
          txnId,
          otp: otp.join(""), // Combine OTP digits into a single string
          mobileNo: mobileNumber,
        };
        console.log("Payload for Aadhaar Authentication API:", payload);

        try {
          const response = await fetch(`${API_URL1}abdm/verify-otp-adhar?orgId=675ae64b2b79c071f8da4799`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(payload),
          });
          const data = await response.json();
          if (response.ok) {
            if (data.data && data.message && data.status === 200) {
              toast.success(data.message);

              setAadhaarResponse(data.data);
              setOtpSent(data.data.otpSent);
              if (data.data.otpSent) {
                setCommOtpTimer(60);
              }
              setmobileMesaage(data.data.message || "");
              setCurrentStep(3);
            } else {
              toast.error(
                data.message ||
                  "Aadhaar Authentication failed. Please try again."
              );
            }
          } else {
            if (
              data.data === "UIDAI Error code : 400 : OTP validation failed"
            ) {
              toast.error("OTP validation failed");
            } else {
              toast.error(
                data.data ||
                  "Aadhaar Authentication failed. Please enter the valid OTP."
              );
            }
          }
        } catch (error) {
          console.error("Network Error while verifying OTP:", error);
          toast.error(
            "An error occurred during Aadhaar Authentication. Please try again."
          );
        }
      } else if (currentStep === 3) {
        setCurrentStep(currentStep + 1);
        setIsLoading(false);
        return;
      } else if (currentStep === 4) {
        console.log("Step 4: ABHA Address Creation...");

        const regex =
          /^(?![._])([A-Za-z0-9]+([._][A-ZaZ0-9]+)*[A-Za-z0-9]){8,18}$/;

        if (!isValidAbhaAddress(abhaAddress)) {
          const error =
            "Address must be between 8 to 18 characters and can include letters, numbers, dot (.), and underscore (_).";
          console.error(error);
          setAbhaAddressError(error);
          return;
        }

        if (!isValidAbhaAddress(abhaAddress)) {
          toast.error(
            "The entered ABHA address is not valid. Please try a valid one."
          );
          return;
        }

        // API Call to create ABHA Address
        try {
          const apiUrl = `${API_URL1}abdm/abhaAddressCreate?txnId=${aadhaarResponse.txnId}&address=${abhaAddress}`;

          const response = await fetch(apiUrl, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
          });
          const data = await response.json();
          if (response.ok) {
            if (data.status === 200 && data.message) {
              toast.success("ABHA Address created successfully!");
              
              // Call onSuccess callback with the data
              if (onSuccess && data.data) {
                // Transform the data to match the expected structure
                const abhaData = {
                  abhaProfile: {
                    abhaNumber: data.data.healthIdNumber,
                    preferredAbhaAddress: data.data.preferredAbhaAddress
                  }
                };
                onSuccess(abhaData);
              }
              
              onClose(); // Close the modal after successful creation
            } else {
              toast.error(
                data.message ||
                  "Failed to create ABHA Address. Please try again."
              );
            }
          } else {
            toast.error(
              data.data ||
                "Failed to create ABHA Address. Please try again later."
            );
          }
        } catch (error) {
          console.error("Error during ABHA Address creation API call:", error);
          toast.error(
            "An error occurred while creating ABHA Address. Please try again."
          );
        }
      }
    } catch (error) {
      console.error("Unexpected Error:", error);
      toast.error("An unexpected error occurred. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  const handlePreviousStep = () => {
    setCurrentStep(currentStep - 1); // Move to the previous step
  };

  const accept = () => {
    setCurrentStep(4);
    setIsModalOpen(false);
  };

  const reject = () => {
    toast.current.show({
      severity: "warn",
      summary: "Rejected",
      detail: "You have rejected",
      life: 3000,
    });
  };

  const showConfirm = (event) => {
    setIsModalOpen(false);
    setVisible(true);
  };

  return (
    <>
      {showAsModal ? (
        <Modal
          title="Create ABHA Number Using Aadhaar"
          open={isOpen}
          onCancel={onClose}
          footer={null}
          width="90%"
          style={{ top: 20 }}
          bodyStyle={{ maxHeight: '80vh', overflow: 'auto' }}
        >
          <div className="relative">
            {isLoading && (
              <div className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                <div className="w-16 h-16 border-4 border-t-teal-600 border-gray-300 rounded-full animate-spin"></div>
              </div>
            )}
            <div className="bg-white rounded-lg w-full">
              {/* Header Section */}
              <div className="flex justify-between items-center mb-6">
                <h2 className="text-2xl font-bold text-teal-600">
                  Create ABHA Number Using Aadhaar
                </h2>
                <p className="text-black text-sm">{currentStep}/4</p>
              </div>

              {/* Tabs Section */}
              <div className="flex items-center border-b-2 border-gray-200 mb-6">
                <div
                  className={`flex-1 text-center pb-2 ${
                    currentStep === 1
                      ? "border-b-4 border-teal-600 font-semibold text-black"
                      : "text-gray-500"
                  }`}
                >
                  Consent Collection
                </div>
                <div
                  className={`flex-1 text-center pb-2 ${
                    currentStep === 2
                      ? "border-b-4 border-teal-600 font-semibold text-black"
                      : "text-gray-500"
                  }`}
                >
                  Aadhaar Authentication
                </div>
                <div
                  className={`flex-1 text-center pb-2 ${
                    currentStep === 3
                      ? "border-b-4 border-teal-600 font-semibold text-black"
                      : "text-gray-500"
                  }`}
                >
                  Communication Details
                </div>
                <div
                  className={`flex-1 text-center pb-2 ${
                    currentStep === 4
                      ? "border-b-4 border-teal-600 font-semibold text-black"
                      : "text-gray-500"
                  }`}
                >
                  ABHA Address Creation
                </div>
              </div>

              {/* Step Content */}
              {currentStep === 1 && (
                <form>
                  <div className="mb-6">
                    <label
                      htmlFor="aadhaar"
                      className="block text-sm font-medium text-black mb-2"
                    >
                      Aadhaar number<span className="text-red-500">*</span>
                    </label>
                    <div className="flex items-center space-x-2">
                      {aadhaar.map((num, index) => (
                        <input
                          key={index}
                          type={showAadhaar ? "text" : "password"} // Toggle between 'text' and 'password'
                          placeholder="0000"
                          maxLength="4"
                          value={num}
                          onChange={(e) =>
                            handleAadhaarChange(index, e.target.value)
                          }
                          onKeyDown={(e) => handleAadhaarKeyDown(index, e)}
                          className="w-16 p-2 border border-gray-300 rounded-md text-center text-black"
                          aria-label={`Aadhaar segment ${index + 1}`}
                          ref={(el) => (inputRefs.current[index] = el)} // Assign ref to each input
                        />
                      ))}
                      <button
                        type="button"
                        onClick={toggleShowAadhaar}
                        className="ml-2 text-gray-600 hover:text-gray-800 focus:outline-none"
                        aria-label={
                          showAadhaar
                            ? "Hide Aadhaar number"
                            : "Show Aadhaar number"
                        }
                      >
                        {showAadhaar ? <FaEyeSlash /> : <FaEye />}
                      </button>
                    </div>
                    <p className="text-sm text-black mt-6">
                      Please ensure that mobile number is linked with Aadhaar as
                      it will be required for OTP authentication.
                    </p>
                  </div>

                  <div className="mb-6">
                    <p className="text-sm font-medium text-black mb-2">
                      I hereby declare that :
                    </p>
                    <div className="p-4 border-2 border-dashed border-gray-400 rounded-lg space-y-4">
                      {consentItems.map(({ key, label }) => {
                        if (key === "beneficiaryConsent") {
                          return (
                            <div
                              key={key}
                              className="flex items-start space-x-3 mb-4"
                            >
                              <input
                                id={key}
                                type="checkbox"
                                checked={consentState[key]}
                                onChange={() =>
                                  setConsentState((prev) => ({
                                    ...prev,
                                    [key]: !prev[key],
                                  }))
                                }
                                className="flex-none h-5 w-5 text-teal-600 border-gray-300 rounded-sm"
                              />
                              <label
                                htmlFor={key}
                                className="block text-sm text-black break-words leading-snug"
                              >
                                I,&nbsp;
                                <input
                                  type="text"
                                  placeholder="Enter Patient Name"
                                  value={beneficiaryName}
                                  onChange={(e) =>
                                    setBeneficiaryName(e.target.value)
                                  }
                                  className="inline-block w-32 border-b border-gray-400 focus:outline-none align-text-bottom mx-1 py-0 text-sm"
                                />
                                &nbsp;have been explained about the consent as
                                stated above and hereby provide my consent for the
                                aforementioned purposes.
                              </label>
                            </div>
                          );
                        }

                        return (
                          <div
                            key={key}
                            className="flex items-start space-x-3 mb-4"
                          >
                            <input
                              id={key}
                              type="checkbox"
                              checked={consentState[key]}
                              onChange={() =>
                                setConsentState((prev) => ({
                                  ...prev,
                                  [key]: !prev[key],
                                }))
                              }
                              className="flex-none h-5 w-5 text-teal-600 border-gray-300 rounded-sm"
                            />
                            <label
                              htmlFor={key}
                              className="text-black text-sm leading-snug break-words"
                            >
                              {label}
                            </label>
                          </div>
                        );
                      })}
                    </div>
                  </div>

                  {/* Captcha */}
                  <div className="mb-6">
                    <label
                      htmlFor="captcha"
                      className="block text-sm font-medium text-black mb-2"
                    >
                      Captcha<span className="text-red-500">*</span>
                    </label>
                    <div className="flex items-center space-x-4">
                      <div className="flex items-center justify-center border border-gray-300 rounded-md w-20 h-12 text-black">
                        {captcha.question}
                      </div>
                      <input
                        type="text"
                        id="captcha"
                        placeholder="Enter answer"
                        value={captchaAnswer}
                        onChange={(e) => handleCaptchaChange(e.target.value)}
                        className="flex-1 p-2 border border-gray-300 rounded-md text-black"
                      />
                      <button
                        type="button"
                        onClick={refreshCaptcha}
                        className="text-teal-600 hover:text-teal-800"
                      >
                        &#x21bb;
                      </button>
                    </div>
                  </div>
                </form>
              )}

              {currentStep === 2 && (
                <div>
                  {/* Aadhaar Authentication Step */}
                  <div className="mb-6">
                    <label
                      htmlFor="otp"
                      className="block text-sm font-medium text-black mb-2"
                    >
                      Confirm OTP<span className="text-red-500">*</span>
                    </label>
                    <p className="text-sm text-gray-600 mb-2">
                      {otpMessage || "OTP sent to mobile number"}
                    </p>
                    <div className="flex space-x-2">
                      {otp.map((digit, index) => (
                        <input
                          key={index}
                          type="text"
                          maxLength="1"
                          value={digit}
                          onChange={(e) => handleOtpChange(e.target.value, index)}
                          onKeyDown={(e) => handleOtpKeyDown(index, e)}
                          ref={(el) => (otpRefs.current[index] = el)}
                          className="w-10 h-12 p-2 border border-gray-300 rounded-md text-center text-black text-lg"
                          placeholder="0"
                        />
                      ))}
                    </div>
                    {aadhaarResendAttempts < MAX_AADHAAR_RESEND_ATTEMPTS ? (
                      <p className="text-sm text-gray-600 mt-2">
                        Didn't receive OTP?{" "}
                        <button
                          type="button"
                          className={`text-teal-600 underline ${
                            isAadhaarResendDisabled
                              ? "opacity-50 cursor-not-allowed"
                              : "hover:text-teal-800"
                          }`}
                          onClick={handleResendAadhaarOtp}
                          disabled={isAadhaarResendDisabled}
                        >
                          Resend OTP
                        </button>{" "}
                        <span className="text-gray-500">
                          ({aadhaarOtpTimer}s remaining) •{" "}
                          {MAX_AADHAAR_RESEND_ATTEMPTS - aadhaarResendAttempts}{" "}
                          attempt
                          {MAX_AADHAAR_RESEND_ATTEMPTS - aadhaarResendAttempts > 1
                            ? "s"
                            : ""}{" "}
                          left
                        </span>
                      </p>
                    ) : (
                      <p className="text-sm text-red-500 mt-2">
                        Resend OTP exhausted.
                      </p>
                    )}
                  </div>

                  {/* Mobile Number Input */}
                  <div className="mb-6">
                    <label
                      htmlFor="mobile"
                      className="block text-sm font-medium text-black mb-2"
                    >
                      Mobile number<span className="text-red-500">*</span>
                    </label>
                    <div className="flex">
                      <span className="inline-flex items-center px-3 border border-gray-300 bg-gray-50 text-gray-600 rounded-l-md">
                        +91
                      </span>
                      <input
                        type="text"
                        id="mobile"
                        placeholder="Enter your mobile number"
                        value={mobileNumber}
                        onChange={(e) => {
                          const value = e.target.value;
                          if (/^\d{0,10}$/.test(value)) {
                            setMobileNumber(value);
                          }
                        }}
                        className="w-full p-2 border border-gray-300 rounded-r-md text-black"
                      />
                    </div>
                    <p className="text-sm text-gray-600 mt-2">
                      This mobile number will be used for all communications
                      related to ABHA.
                    </p>
                  </div>

                  {/* Error Message */}
                  {errorMessage && (
                    <p className="text-red-500 text-sm mt-2">{errorMessage}</p>
                  )}
                </div>
              )}

              {currentStep === 3 && (
                <div>
                  <h3 className="text-lg font-bold text-teal-600 mb-4">
                    Verify Communication Details
                  </h3>

                  {otpSent ? (
                    <>
                      {/* Mobile Verification Message */}
                      <div className="mb-6">
                        <div className="flex items-center">
                          <div className="w-full p-2 rounded-r-md text-black">
                            {mobileMesaage}
                          </div>
                        </div>
                      </div>

                      {/* OTP Input */}
                      <div className="mb-6">
                        <label className="block text-sm font-medium text-black mb-2">
                          Enter OTP<span className="text-red-500">*</span>
                        </label>
                        {commResendAttempts < MAX_AADHAAR_RESEND_ATTEMPTS ? (
                          <p className="text-sm text-gray-600 mt-2 mb-3">
                            Didn't receive OTP?{" "}
                            <button
                              type="button"
                              className={`text-teal-600 underline ${
                                isCommResendDisabled || commResendAttempts >= 2
                                  ? "opacity-50 cursor-not-allowed"
                                  : "hover:text-teal-800"
                              }`}
                              onClick={handleResendOtpConfirm}
                              disabled={
                                isCommResendDisabled || commResendAttempts >= 2
                              }
                            >
                              Resend OTP
                            </button>{" "}
                            <span className="text-gray-500">
                              ({commOtpTimer}s remaining) •{" "}
                              {MAX_AADHAAR_RESEND_ATTEMPTS - commResendAttempts}{" "}
                              attempt
                              {MAX_AADHAAR_RESEND_ATTEMPTS - commResendAttempts >
                              1
                                ? "s"
                                : ""}{" "}
                              left
                            </span>
                          </p>
                        ) : (
                          <p className="text-sm text-red-500 mt-2">
                            Resend OTP exhausted.
                          </p>
                        )}

                        <div className="flex space-x-2">
                          {otp.map((digit, index) => (
                            <input
                              key={index}
                              type="text"
                              maxLength="1"
                              value={digit}
                              onChange={(e) =>
                                handleOtpChange(e.target.value, index)
                              }
                              onKeyDown={(e) => handleOtpKeyDown(index, e)}
                              ref={(el) => (otpRefs.current[index] = el)}
                              className="w-10 h-12 p-2 border border-gray-300 rounded-md text-center text-black text-lg"
                              placeholder="0"
                            />
                          ))}
                        </div>

                        {/* Verify Button */}
                        <div className="flex mt-4 space-x-4">
                          <button
                            type="button"
                            className="px-6 py-2 bg-teal-600 text-white rounded-md hover:bg-teal-700"
                            onClick={handleVerifyMobileOtp}
                          >
                            {isLoading ? (
                              <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin mx-auto" />
                            ) : (
                              "Verify"
                            )}
                          </button>
                        </div>
                      </div>
                    </>
                  ) : (
                    <>
                      {/* Email Verification Input */}
                      <div className="mb-6">
                        <label className="block text-sm font-medium text-black mb-2">
                          Email Address
                        </label>
                        <div className="flex">
                          <input
                            type="email"
                            id="email"
                            placeholder="Enter your email address"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            className="w-full p-2 border border-gray-300 rounded-l-md text-black"
                          />
                          <button
                            type="button"
                            className={`ml-4 px-4 py-2 rounded-md ${
                              email.length > 0
                                ? "bg-teal-600 text-white hover:bg-teal-700"
                                : "bg-gray-300 text-gray-600 cursor-not-allowed"
                            }`}
                            disabled={email.length === 0 || isLoading}
                            onClick={handleSendEmailOtp}
                          >
                            {isLoading ? (
                              <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin mx-auto"></div>
                            ) : (
                              "Verify"
                            )}
                          </button>
                        </div>
                      </div>

                      {/* Skip Button */}
                      <div className="flex justify-end">
                        <button
                          type="button"
                          className="px-6 py-2 bg-teal-600 text-white rounded-md hover:bg-teal-700"
                          onClick={handleNextStep}
                        >
                          Skip
                        </button>
                      </div>
                    </>
                  )}
                </div>
              )}

              {currentStep === 4 && (
                <div>
                  {/* ABHA Address Creation */}
                  <h3 className="text-lg font-bold text-teal-600 mb-4">
                    Create Your Unique ABHA Address
                  </h3>

                  {/* Description */}
                  <p className="text-sm text-gray-600 mb-4">
                    ABHA (Ayushman Bharat Health Account) address is a unique
                    username that allows you to share and access your health
                    records digitally. It is similar to an email address but is
                    only used for health records.
                  </p>
                  <p className="text-sm text-gray-600 mb-6">
                    To create an ABHA address, it should have Min - 8 characters,
                    Max - 18 characters. Special characters allowed - 1 dot (.)
                    and/or 1 underscore (_).
                  </p>

                  {/* ABHA Address Input */}
                  <div className="mb-6">
                    <label
                      htmlFor="abhaAddress"
                      className="block text-sm font-medium text-black mb-2"
                    >
                      Enter ABHA address<span className="text-red-500">*</span>
                    </label>
                    <div className="flex">
                      <input
                        type="text"
                        id="abhaAddress"
                        placeholder="Enter ABHA address"
                        value={abhaAddress}
                        onChange={(e) => handleAbhaAddressChange(e.target.value)}
                        className="w-full p-2 border border-gray-300 rounded-l-md text-black"
                      />
                      <span className="inline-flex items-center px-3 border border-gray-300 bg-gray-50 text-gray-600 rounded-r-md">
                        @sbx
                      </span>
                    </div>
                    {abhaAddressError && (
                      <p className="text-red-500 text-sm mt-2">
                        {abhaAddressError}
                      </p>
                    )}
                  </div>

                  {/* Suggestions */}
                  {suggestions && suggestions.length > 0 && (
                    <div className="mb-6">
                      <p className="text-sm font-medium text-gray-700 mb-2">
                        Suggestions:
                      </p>
                      <div className="flex flex-wrap gap-2">
                        {suggestions.map((suggestion, index) => (
                          <button
                            key={index}
                            type="button"
                            onClick={() => setAbhaAddress(suggestion)}
                            className="px-3 py-1 border border-gray-300 rounded-md bg-gray-100 text-black hover:bg-gray-200"
                          >
                            {suggestion}
                          </button>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              )}

              {/* Buttons */}
              <div className="flex justify-between mt-6">
                {currentStep > 1 && (
                  <button
                    type="button"
                    className="px-6 py-2 text-black border border-gray-300 rounded-md hover:bg-gray-100"
                    onClick={handlePreviousStep}
                  >
                    Back
                  </button>
                )}
                {currentStep != 3 && (
                  <button
                    type="button"
                    className="px-6 py-2 bg-teal-600 text-white rounded-md hover:bg-teal-700"
                    onClick={handleNextStep}
                  >
                    {currentStep === 4 ? "Create ABHA" : "Next"}
                  </button>
                )}
              </div>
            </div>
          </div>
        </Modal>
      ) : (
      ""
      )}
      <ToastContainer />
      <Modal
        isOpen={visible}
        onRequestClose={() => setVisible(false)}
        style={{
          overlay: {
            backgroundColor: "rgba(0, 0, 0, 0.3)", // Softer background overlay
          },
          content: {
            width: "400px", // Slightly narrower for a cleaner look
            height: "220px",
            margin: "auto",
            padding: "25px",
            borderRadius: "15px", // Smooth rounded corners
            textAlign: "center",
            boxShadow: "0px 8px 20px rgba(0, 0, 0, 0.2)", // Softer, larger shadow
          },
        }}
        ariaHideApp={false}
      >
        <h2 className="text-xl font-semibold text-teal-600 mb-6">
          Are you sure you want to create new ABHA Address?
        </h2>
        <div className="flex flex-row justify-center gap-4">
          <button
            onClick={() => {
              setVisible(false);
              setCurrentStep(4);
            }}
            className="flex items-center justify-center px-5 py-2 bg-teal-500 text-white rounded-full hover:bg-teal-600 focus:ring-2 focus:ring-teal-300 focus:outline-none transition duration-200"
          >
            <FaCheck className="mr-2" /> Yes
          </button>

          <button
            onClick={() => {
              setVisible(false);
              setIsModalOpen(true);
            }}
            className="flex items-center justify-center px-5 py-2 bg-gray-300 text-gray-700 rounded-full hover:bg-gray-400 focus:ring-2 focus:ring-gray-200 focus:outline-none transition duration-200"
          >
            <FaTimes className="mr-2" /> No
          </button>
        </div>
      </Modal>
    </>
  );
};

export default CreateAbhaModal;
